import initDesktopHeader from "./components/GlobalHeader/initDesktopHeader.js";
import initMobileHeader from "./components/GlobalHeader/initMobileHeader.js";
import renderQuickSearchBar from "./components/QuickSearchBar/renderQuickSearchBar.jsx";

document.addEventListener("DOMContentLoaded", () => {
  initMobileHeader();
  initDesktopHeader();
  renderQuickSearchBar();
});
